import React from 'react';
import PropTypes from 'prop-types';
import { Utils } from 'versafleet-core';
import ReduxActions from 'reduxActions';
import { connect } from 'react-redux';
import { Outlet } from 'react-router-dom';

class AuthenticationNew extends React.Component {
  UNSAFE_componentWillMount() {
    // The initial check does not require any error to be displayed,
    // therefore the catch block is only there to prevent unhandled promises
    this.props.dispatch(ReduxActions.profile.check())
      .catch(() => {});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isChecked && !Utils.Helper.isNullOrUndefined(nextProps.profile)) {
      Utils.Router.transitionTo('/home');
    }
  }

  render() {
    return this.props.isChecked ? (
      <div className="vf-authentication vf-authentication__background">
        <Outlet />
        <img
          alt="truck"
          className="vf-authentication__truck"
          src="/assets/images/versafleet_RushingTruck.png"
        />
      </div>
    ) : false;
  }
}

AuthenticationNew.displayName = 'Authentication New';

AuthenticationNew.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  profile: PropTypes.shape({}).isRequired,
};

function mapStateToProps(state) {
  const { profile } = state;

  return {
    profile: profile.profile,
    isChecked: profile.isChecked,
  };
}

export default connect(mapStateToProps)(AuthenticationNew);
